// meetingModel.js
import { collection, doc } from "firebase/firestore";
import { db } from "../../firebase/firebase.js";

export const meetingRequestsCollection = collection(db, "meetingRequests");

export const meetingRequestDoc = (id) => doc(db, "meetingRequests", id);

